
import required from './required';

// Round a number to given decimals
export default function round(number = required(), decimals = 2) {
  return Math.round(number * `1e${decimals}`) / `1e${decimals}`;
}



// WEBPACK FOOTER //
// ./website/vendor/scripts/fabrique/modules/number-round.js